export const toLocalDateTimeInput = (date: string | Date) => {
  const d = new Date(date);

  const tzOffset = d.getTimezoneOffset() * 60000;

  return new Date(d.getTime() - tzOffset).toISOString().slice(0, 16);
};

export const localInputToUTC = (value: string) => {
  return new Date(value).toISOString();
};
